import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './ProcessStep.css';

const ProcessStep = ({ number, icon: Icon, title, description }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <div
      ref={ref}
      className={`process-step fade-in-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="step-number">{number}</div>
      <div className="step-icon">
        <Icon />
      </div>
      <h4 className="step-title">{title}</h4>
      <p className="step-description">{description}</p>
    </div>
  );
};

export default ProcessStep;
